const uniquePrimitives = primitives => [...new Set(primitives)]

export default uniquePrimitives
